import React from "react";
import { Toast as BTToast, ToastContainer } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { CloseAlert } from "../redux/alert/action";
import { ToastType } from "../redux/alert/reducer";
import { useAppTranslation } from "../i18n/useAppTranslation";
type Props = {};

const Toast = (props: Props) => {
  const alert: ToastType = useSelector((state: any) => state?.alert);
  const dispatch = useDispatch();
  const { t } = useAppTranslation("common");

  function closeToast() {
    dispatch(
      CloseAlert({
        ...alert,
        open: false,
      })
    );
  }

  return (
    <ToastContainer containerPosition="fixed" position="bottom-start">
      <BTToast
        bg={alert?.variant === "error" ? "danger" : alert?.variant}
        onClose={closeToast}
        show={alert?.open}
        delay={7000}
        autohide
      >
        <BTToast.Header>

          <strong className="me-auto">
            {alert?.title
              ? alert.title
              : alert?.variant === "error"
              ? t("common:toastTitles.error")
              : alert?.variant === "warning"
              ? t("common:toastTitles.warning")
              : alert?.variant === "success"
              ? t("common:toastTitles.success")
              : t("common:toastTitles.comingSoon")}
          </strong>
          {/* <small>11 mins ago</small> */}
        </BTToast.Header>
        <BTToast.Body>{alert?.msg}</BTToast.Body>
      </BTToast>
    </ToastContainer>
  );
};

export default Toast;
